<nb-card status="primary">
  <nb-card-header>
    <div class="row">
      <div class="col-sm-10">
        <strong>Mudar Perfil de Usuário</strong>
      </div>
      <div class="col-sm-2 d-flex justify-content-end">
        <button nbSuffix nbButton ghost (click)="close()" size="tiny" status="basic">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-header>
  
  <nb-card-body>
    <p>
      Selecione o usuário para o qual deseja mudar o perfil.
    </p>
    
    <div class="row mt-3">
      <div class="col-sm-12">
        <label id="selectUsuario">Usuário</label>
        <div class="custom-autocomplete-wrapper">
          <input 
            type="text"
            class="form-control autocomplete-input"
            #inputUsuario
            [(ngModel)]="searchUsuario"
            (input)="onSearchUsuarioInput($event)"
            (focus)="onUsuarioFocus($event)"
            (blur)="onUsuarioBlur()"
            placeholder="Selecione"
            [disabled]="loadingUsuarios">
          
          <div class="autocomplete-dropdown" 
               *ngIf="showUsuarioDropdown && filteredUsuario.length > 0"
               [style.top.px]="dropdownTop"
               [style.left.px]="dropdownLeft"
               [style.width.px]="dropdownWidth">
            <div 
              *ngFor="let option of filteredUsuario; trackBy: trackByValue"
              class="autocomplete-option"
              (click)="selectUsuarioOption(option)"
              [class.selected]="option.value === usuarioSelecionado">
              {{ option.label }}
            </div>
          </div>
          
          <div class="autocomplete-dropdown" 
               *ngIf="showUsuarioDropdown && filteredUsuario.length === 0 && searchUsuario.length > 0"
               [style.top.px]="dropdownTop"
               [style.left.px]="dropdownLeft"
               [style.width.px]="dropdownWidth">
            <div class="no-results">Nenhum resultado encontrado</div>
          </div>
        </div>
        <div *ngIf="!listaUsuarios || listaUsuarios.length === 0" class="text-warning mt-1">
          Carregando lista de usuários...
        </div>
      </div>
    </div>
  </nb-card-body>
  
  <nb-card-footer>
    <button nbButton 
      status="primary"
      (click)="mudarPerfil()"
      [disabled]="!usuarioSelecionado || loadingUsuarios">
      Mudar Perfil
    </button>
    <button nbButton 
      status="basic"
      (click)="close()"
      class="ml-2">
      Cancelar
    </button>
  </nb-card-footer>
</nb-card>
